module.exports = __webpack_public_path__ + "static/media/agent-minimum-trade.dbb5f3e2.jpg";